/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this.$section = $section;
    this.$el = $('#header');
    this.$mobileEl = $('#mobile-header');
    this.$wrapper = this.$el.closest('[data-enable_sticky]');
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    this._stickyOffset = 0;

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header: track "is it currently stuck" + measured offsets
    if (this.enable_sticky === true) {
      this.initStickyObserver();
      this.initHeaderOffsetTracking();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click',  '[data-show-search-trigger]', function(){
      window.PXUTheme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function(e) {
        var $this = $(this);
        window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        window.PXUTheme.jsHeader.showSearch();
      }
    });

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  // Watches a sentinel in layout/theme.liquid (needs to be a sibling of the header).
  // If AnnouncementBar and/or TopBar are enabled, these sit between the sentinel
  // and the header, so the sticky trigger point needs a rootMargin offset.
  initStickyObserver: function() {
    this._sentinelEl = document.querySelector('.sticky-header-sentinel');
    if (!this._sentinelEl || typeof IntersectionObserver === 'undefined') return;

    this.createStickyObserver();
  },
  createStickyObserver: function() {
    if (!this._sentinelEl || !this.$section.length) return;

    if (this._stickyObserver) {
      this._stickyObserver.disconnect();
    }

    // Positive when there's non-sticky content (e.g. the top bar) between the
    // sentinel and the header's resting position - rootMargin needs to grow
    // the root by that amount.
    const marginTop = this.$section[0].offsetTop - this._stickyOffset;

    this._stickyObserver = new IntersectionObserver((entries) => {
      this.setStuckState(!entries[0].isIntersecting);
    }, {
      rootMargin: `${marginTop}px 0px 0px 0px`,
      threshold: 0,
    });

    this._stickyObserver.observe(this._sentinelEl);
  },
  setStuckState: function(isStuck) {
    this.$wrapper.toggleClass('is-sticky', isStuck);
    this.$wrapper.find('.search-overlay').toggleClass('sticky-search', isStuck);

    if (isStuck) {
      if (this.enable_overlay === true) {
        this.disableOverlayStyle();

        if (this.sectionUnderlayIsImage() === true) {
          this.$wrapper.addClass('has-overlaid-header');
        }
      }
    } else {
      this.$wrapper.removeClass('has-overlaid-header');
      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(true);
      }
    }
  },
  // Keeps the search overlay positioned directly under whichever header is
  // currently visible.
  initHeaderOffsetTracking: function() {
    if (typeof ResizeObserver === 'undefined') return;

    this._offsetObserver = new ResizeObserver(() => {
      this.updateHeaderOffset();
    });

    if (this.$el.length) this._offsetObserver.observe(this.$el[0]);
    if (this.$mobileEl.length) this._offsetObserver.observe(this.$mobileEl[0]);

    this.updateHeaderOffset();
  },
  updateHeaderOffset: function() {
    const $activeHeader = isScreenSizeLarge() ? this.$el : this.$mobileEl;
    const height = $activeHeader.outerHeight() || 0;

    if (this.$wrapper.length) {
      this.$wrapper[0].style.setProperty('--sticky-header-offset', height + 'px');
    }
  },
  // Called by jsAnnouncementBar whenever the (optionally sticky) announcement
  // bar's height changes to adjust header offset.
  updateAnnouncementOffset: function(height) {
    this._stickyOffset = height || 0;
    document.documentElement.style.setProperty('--announcement-height', this._stickyOffset + 'px');
    this.createStickyObserver();
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');

    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
        },
        afterShow: function() {
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
      })
    }
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    this.$menuToggle.off();

    // Only tear down the sticky observers on a section unload,
    // not on desktop -> mobile layout change.
    if ($section) {
      if (this._stickyObserver) this._stickyObserver.disconnect();
      if (this._offsetObserver) this._offsetObserver.disconnect();
    }

    this.disableOverlayStyle();
  }
}

/******/ })()
;
